import Vue from 'vue';

type State = {
  count: number;
};

const state = Vue.observable<State>({
  count: 0,
});

export default Vue.extend({
  name: 'EventObserverMixin',

  computed: {
    // これを継承先で監視する想定
    eventCount(): number {
      return state.count;
    },
  },

  methods: {
    publishEvent(): void {
      state.count++;
    },
  },
});
